import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=1d7bbecc&scoped=true&"
import script from "./PersonalCenter.vue?vue&type=script&lang=ts&"
export * from "./PersonalCenter.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=1d7bbecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bbecc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VFlex,VForm,VIcon,VLayout,VSubheader,VTextField})
